// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.menuSettingsHeader {\n  padding-bottom: 34px;\n  margin-top: -25px;\n}\n.menuSettingsHeader > .v-tabs__bar {\n  background: none;\n}\n.menuSettingsHeader .v-icon {\n  font-size: 36px;\n}\n.menuSettingsHeader .v-tabs__item {\n  font-weight: 700;\n}\n", ""]);
// Exports
module.exports = exports;
